import API from '../../services/API';

import {
    environmentActionTypes,
    errorActionTypes,
    messagesActionTypes,
    modalActionTypes,
    spinnerActionTypes,
    commonSagaActionTypes,
    zipCodeActionTypes
} from '../../constants/actionTypes/commonActionTypes';
import { configs } from '../../constants/configs/configs';
import { commonModalTypes } from '../../constants/common/modals/commonModalTypes';
import { entityModalTypes,transferStatusTypes } from '../../constants/entity/modals/entityModalTypes';

let interval;


export const startSpinner = message => ({
    type: spinnerActionTypes.START_SPINNER,
    message
});

export const stopSpinner = () => ({
    type: spinnerActionTypes.STOP_SPINNER
});

export const setError = errorData => ({
    type: errorActionTypes.SET_ERROR,
    errorData
});

export const setUnreadMessageCount = envData => ({
    type: environmentActionTypes.UPDATE_ICON_UNREAD_COUNT,
    envData
});

export const updateEnvironmentProp = (path, value) => ({
    type: environmentActionTypes.UPDATE_PROP,
    path,
    value
});

export const setEnvironments = envData => ({
    type: environmentActionTypes.SET_ENVIRONMENTS,
    envData
});

export const getEnvironment = () => ({
    type: commonSagaActionTypes.GET_ENVIRONMENT
});

export const setExplainerData = ({ pageName, data }) => ({
    type: environmentActionTypes.UPDATE_EXPLAINER_DATA,
    pageName,
    data
});

export const setLoadedMessages = (loadedLanguages) => ({
    type: messagesActionTypes.SET_LOADED_MESSAGES,
    loadedLanguages: loadedLanguages
});

export const setMessages = (messages, lang) => ({
    type: messagesActionTypes.SET_MESSAGES,
    messages,
    lang
});

export const setLanguage = language => ({
    type:  environmentActionTypes.CHANGE_LANG,
    language
});



export const changeLang = (url) => async dispatch => {
    const data = await API.getData(url, dispatch, actions);
    return data.message === 'success' && dispatch(setLanguage(data.lang));

};
export const hideModal = modalType => ({
    type: modalActionTypes.HIDE_MODAL,
    modalType
});


export const hideAllModals = () => ({
    type: modalActionTypes.HIDE_ALL_MODALS
});

export const showModal = ({ modalData, modalType }) => ({
    type: modalActionTypes.SHOW_MODAL,
    modalData,
    modalType
});

const actions = { startSpinner, stopSpinner, setError };

export const fetchUnreadMessages = (...args) => async dispatch => {
    const [ url, body ] = args;
    const params = [ url, body, global.__ENV__.DEVELOPMENT ? 'GET' : undefined, false];

    const data = await API.postData(params, dispatch, actions);

    if(data) {
        dispatch(setUnreadMessageCount(data));
    } else {
        dispatch(setUnreadMessageCount( null ));
    }

};

// export const fetchEnvironmentData = () => async dispatch => {
//
//     const url = configs.endpoints.ENVIRONMENT_VARIABLES.processReplacements({
//         stateCode: localStorageHyperDashboardTools.getValueByPropName('stateCode', 'NV')
//     });
//
//     const data = await API.getData(url, dispatch, actions);
//
//     if(data) {
//         window.UID = data.user && data.user.userId;
//         window.EMAIL = data.user && data.user.userName;
//
//         const { serverDate, oepStartDate, oepEndDate, oepEnrollStartDate, oepEnrollEndDate, exceptionalCircumstancesStartDate, exceptionalCircumstancesEndDate, timezone } = data.localDates;
//
//         serverDate && localStorage.setItem('serverDate', moment(serverDate).format('MM/DD/YYYY'));
//
//         try{
//             const FAV_ICON = data.assets.FAV_ICON;
//             document.getElementById('favicon').setAttribute('href', FAV_ICON);
//         } catch(e) {
//             global.__ENV__.PRODUCTION && console.log('It is not able to set favicon');
//         }
//
//         const stateCode = global.__ENV__.DEVELOPMENT
//             ? localStorageHyperDashboardTools.getValueByPropName('stateCode', 'NV')
//             : data.stateCode;
//
//         const isState = Object
//             .values(configs.states)
//             .reduce((res, stateName) => ({
//                 ...res,
//                 [stateName]: stateName === stateCode
//             }) , {});
//
//         const localDates = {
//             serverDate: serverDate ? serverDate : new Date().getTime(),
//             // To support 8888, by default (when serverDate === null in mock) serverDate === actual developer's machine date
//             oepStartDate,
//             oepEndDate,
//             oepEnrollStartDate,
//             oepEnrollEndDate,
//             exceptionalCircumstancesStartDate,
//             exceptionalCircumstancesEndDate,
//             timezone,
//         };
//
//         // Convert dates into 'MM-DD-YYYY' format.
//         for (let date in localDates) {
//             if(date === 'timezone') {
//                 localDates.timezone = timezone;
//             } else if (date === 'serverDate') {
//                 localDates[date] = dateMethods.formatDateTime(localDates[date]);
//             } else {
//                 localDates[date] = dateMethods.formatDate(localDates[date]);
//             }
//         }
//
//         dispatch(setEnvironments({ ...data, stateCode, isState, localDates }));
//     }
// };

export const setCountyData = data => ({
    type: zipCodeActionTypes.SET_COUNTY_DATA,
    data
});
export const clearCountyData = () => ({
    type: zipCodeActionTypes.CLEAR_COUNTY_DATA
});

export const fetchCounties = (...args) => async dispatch => {
    const [ url ] = args;
    const data = await API.getData(url, dispatch, actions, false);
    if (data) {
        dispatch(setCountyData({ ...data }));
    } else {
        console.error('Counties cannot be fetched', url);
    }
};

export const fetchPingStatus = ( ...args) => async dispatch => {
    const [ url, redirect ]  = args;
    const data = await API.getData(url, dispatch, actions, false);
    if(typeof data !== 'undefined' && data !== null && data === -1) {
        const redirectUrl =  location.origin + redirect['redirect'];
        window.location.href = `${redirectUrl}`;
    }
};

export const fetchExplainerData = pageName => async dispatch => {

    const data = await API.getData(configs.endpoints.EXTERNAL_CONTENT.processReplacements({ pageName }), dispatch, actions);    

    if (data.success) {
        dispatch(setExplainerData({ pageName, data: data.payload }));
    }
};

export const fetchMockModal = (...args) => async dispatch => {

    const [ mockModalType, hhmIndex, areHhms ] = args;

    const data = await API.getData(configs.endpoints.MODAL_MOCKS, dispatch, actions);

    if(data) {

        if(mockModalType === 'default') {
            return null;
        }

        const setMock = () => dispatch(showModal({
            type: modalActionTypes.SHOW_MODAL,
            modalData: data[mockModalType].modalData,
            modalType: mockModalType
        }));

        if(data[mockModalType].shouldHhmsPresent) {
            if(!areHhms) {
                console.log('There no any hhms');
                return null;
            } else {
                setMock();
                return null;
            }
        }

        if(data[mockModalType].shouldCurrentHhmPresent) {
            if(hhmIndex === null) {
                console.log('Chose page with any household member');
                return null;
            } else {
                setMock();
                return null;
            }
        }

        setMock();
    }
};

/**
 * Action for async services to display App in progress modal. Once pending verification is over - run a cb.
 * @returns {function(...[*]=)}
 * @param onPendingFinishedCb
 */
export const checkVerificationPending = (onPendingFinishedCb ) => async (dispatch, getState) => {
    let cnt = 0;
    let timeout = setTimeout(fetchDelayPopupData, 100);

    async function fetchDelayPopupData () {
        cnt++;
        if (cnt > 30) {
            clearTimeout(timeout);
            dispatch(hideModal(commonModalTypes.APP_IN_PROGRESS));
        }
        const data = await API.getData(configs.endpoints.VERIFICATION_PENDING, dispatch, actions, false, getState());
        if (data && data.result === 'success' && data.pending) {
            dispatch(showModal({
                modalType: commonModalTypes.APP_IN_PROGRESS
            }));
            return timeout = setTimeout(fetchDelayPopupData, 5000);
        } else if (data && data.result === 'error') {
            console.error(data.message );
        } else {
            clearTimeout(timeout);
            dispatch(hideModal(commonModalTypes.APP_IN_PROGRESS));
            onPendingFinishedCb();
        }
    }

    return timeout;
};

export const getBOBTransferStatus = (url,intervalFrequency) => async dispatch => {
    const data =  await API.customGetData(url,dispatch,actions,{ 'cache-control':'no-cache', 'If-Modified-Since':'0' });    
    dispatch(hideAllModals());
    if(data.status === transferStatusTypes.NONE){
        return;
    }
    if(data.status === transferStatusTypes.IN_PROGRESS || data.status === transferStatusTypes.PENDING){
        interval = setInterval(() => {
            return dispatch(getBOBTransferStatusInLoop(url));
        }, intervalFrequency);
    }else{
        clearInterval(interval);
    }
    let mType = getModalType(data.status);        
    data && dispatch(showModal({
        modalType: mType,
        modalData : data
    }));        
    
};

export const getBOBTransferStatusInLoop = (url) => async dispatch => {
    const data =  await API.customGetData(url,dispatch,actions,{ 'cache-control':'no-cache', 'If-Modified-Since':'0' });
    dispatch(hideAllModals());
    if(data.status === transferStatusTypes.NONE){
        clearInterval(interval);
        return;
    }
    
    if(!(data.status === transferStatusTypes.IN_PROGRESS || data.status === transferStatusTypes.PENDING)){
        clearInterval(interval);
    }

    let mType = getModalType(data.status);        
    dispatch(showModal({
        modalType: mType,
        modalData : data
    }));        
    
};

export const acknowledgeTransferStatus = url => async dispatch => { 
    await API.customGetData(url,dispatch,actions,{ 'cache-control':'no-cache', 'If-Modified-Since':'0' });
};

export const getModalType = ( status ) => {
    switch(status){
        case transferStatusTypes.IN_PROGRESS:
        case transferStatusTypes.PENDING :{
            return entityModalTypes.TRANSFER_IN_PROGRESS_MODAL;
        }
        case transferStatusTypes.SUCCESS :{
            return entityModalTypes.TRANSFER_SUCCESS_MODAL;
        }
        case transferStatusTypes.PARTIAL_SUCCESS :{
            return entityModalTypes.TRANSFER_PARTIAL_SUCCESS_MODAL;
        }
        case transferStatusTypes.FAILED  : {
            return entityModalTypes.TRANSFER_FAILURE_MODAL;
        }
        case transferStatusTypes.INCOMPLETE :{
            return entityModalTypes.TRANSFER_INCOMPLETE_MODAL;
        }
    }
};

export const SET_SELECTED_MEMBER_DATA_REDUCER = 'SET_SELECTED_MEMBER_DATA_REDUCER';
export const setSelectedMember = (data) => ({
    type: SET_SELECTED_MEMBER_DATA_REDUCER,
    selectedMember: data
});